import { render, staticRenderFns } from "./PadraoLista.vue?vue&type=template&id=51f2a138&scoped=true&"
import script from "./PadraoLista.vue?vue&type=script&lang=js&"
export * from "./PadraoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f2a138",
  null
  
)

export default component.exports